var _defs, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDataPilotLogo = function SvgDataPilotLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.304 57.462"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "data_pilot_logo_svg__a",
    x1: 0.039,
    x2: 1.039,
    y1: 0.502,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff603c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a50f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__b",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__c",
    x1: 0.012,
    x2: 1.01,
    y1: 0.394,
    y2: 0.394
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__d",
    x1: -4.606,
    x2: -3.447,
    y1: 1.434,
    y2: 1.434
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__e",
    x1: -0.722,
    x2: 0.304,
    y1: 0.901,
    y2: 0.901
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__f",
    x1: -1.321,
    x2: -0.252,
    y1: 0.802,
    y2: 0.802
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__g",
    x1: -0.309,
    x2: 0.725,
    y1: 0.637,
    y2: 0.637
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#data_pilot_logo_svg__a",
    id: "data_pilot_logo_svg__h",
    x1: -1.682,
    x2: -0.682,
    y1: 1.243,
    y2: 1.243
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2658"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__a)",
    d: "M35.8 15.637a14.79 14.79 0 0 1-2.162 13.813 15.65 15.65 0 0 1-12.876 6.15A15.54 15.54 0 0 1 5.384 20.058a15.02 15.02 0 0 1 8.991-13.439 16.04 16.04 0 0 1 16.437 2.056 8 8 0 0 0 1.039.673 23 23 0 0 1 1.631-1.888 20 20 0 0 1 1.766-1.853l-.078-.036.078.036.029-.013a21.51 21.51 0 0 0-22.619-3.917A20.18 20.18 0 0 0 .05 20.207a20.57 20.57 0 0 0 12.491 18.8A21.36 21.36 0 0 0 35.6 35.172a19.9 19.9 0 0 0 4.853-22.239q-.127-.3-.264-.6l-.036.012",
    "data-name": "Path 3839",
    transform: "rotate(-8 174.294 -739.744)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__b)",
    stroke: "#fff",
    strokeWidth: 0.25,
    d: "M16.5 30 .032 13.05l14.306 7.712L43.8.1Z",
    "data-name": "Path 3840",
    transform: "rotate(-8 172.438 -769.16)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2659"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__c)",
    d: "M4.307.159a.7.7 0 0 1 .7-.1.68.68 0 0 1 .423.55.66.66 0 0 1-.293.62L1.088 4.161A.7.7 0 0 1 .147 4a.654.654 0 0 1 .115-.919Z",
    "data-name": "Path 3841",
    transform: "rotate(-8 179.113 -1003.437)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__d)",
    d: "M3.43.26a.7.7 0 0 1 1.191.207.65.65 0 0 1-.144.667L1.194 4.856a.7.7 0 0 1-.94.038.657.657 0 0 1-.107-.91Z",
    "data-name": "Path 3842",
    transform: "rotate(-8 195.606 -1021.684)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__e)",
    fillRule: "evenodd",
    d: "M4.462 4.294.008 3.446C4.489-.192 4.733-.022 8.014.037A21.8 21.8 0 0 0 4.462 4.3Z",
    "data-name": "Path 3843",
    transform: "rotate(-8 138.354 -991.476)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__f)",
    fillRule: "evenodd",
    d: "m.007 2.769.136 4.348C4.53 3.373 4.4 3.114 4.885.012A32 32 0 0 1 .007 2.77Z",
    "data-name": "Path 3844",
    transform: "rotate(-8 190.88 -1068.633)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__g)",
    fillRule: "evenodd",
    d: "M16.78 7.781c-1.752 2.853-8.769 8.136-12.539 9.136L.03 12.148c1.54-3.42 8.089-9.331 11.262-10.582 8.352-3.231 10.063-1.4 5.49 6.215Zm-2.745-3.108a2.705 2.705 0 0 1-.343 3.911 2.9 2.9 0 0 1-4.034-.268 2.754 2.754 0 0 1 .3-3.964 2.956 2.956 0 0 1 4.081.32Z",
    "data-name": "Path 3845",
    transform: "rotate(-8 90.317 -1020.292)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#data_pilot_logo_svg__h)",
    d: "M1.662 0a1.66 1.66 0 0 1 1.671 1.628 1.625 1.625 0 0 1-1.658 1.611A1.66 1.66 0 0 1 0 1.615 1.625 1.625 0 0 1 1.662 0",
    "data-name": "Ellipse 15",
    transform: "rotate(-8 120.078 -1095.513)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.368 49.041A1.226 1.226 0 0 1 0 47.641v-23.76a1.226 1.226 0 0 1 1.368-1.4h6.689q5.082 0 7.584 3.226t2.5 10.019q0 6.831-2.5 10.076t-7.584 3.241Zm3.829-4.25h2.9a3.81 3.81 0 0 0 3.655-2.144q1.114-2.144 1.114-6.926 0-4.744-1.114-6.869a3.82 3.82 0 0 0-3.655-2.125H5.199Zm21.194 4.513a5.4 5.4 0 0 1-4.164-1.575 6.13 6.13 0 0 1-1.47-4.343 6.66 6.66 0 0 1 .977-3.586 6.6 6.6 0 0 1 3.166-2.505 15.15 15.15 0 0 1 5.822-.928v-1.025a2.78 2.78 0 0 0-.606-1.879 2.65 2.65 0 0 0-2.091-.7 9.8 9.8 0 0 0-2.541.3 16 16 0 0 0-1.876.607 3.3 3.3 0 0 1-1.055.3q-.352 0-.567-.493a4.6 4.6 0 0 1-.313-1.139 7.4 7.4 0 0 1-.093-1.063q0-.493 1-1.044a10.5 10.5 0 0 1 2.561-.929 13.6 13.6 0 0 1 3.205-.38q3.87 0 5.629 1.723a6.07 6.07 0 0 1 1.76 4.533v7.628a22 22 0 0 0 .2 3.492 9.7 9.7 0 0 1 .2 1.556.69.69 0 0 1-.449.607 4.4 4.4 0 0 1-1.075.363 11 11 0 0 1-1.214.189q-.587.057-.86.057a.96.96 0 0 1-.919-.453 6.2 6.2 0 0 1-.488-1.632 6.6 6.6 0 0 1-1.8 1.575 5.4 5.4 0 0 1-2.939.744m1.566-3.564a2.9 2.9 0 0 0 1.588-.453 3.7 3.7 0 0 0 1.184-1.213v-4.63a6.2 6.2 0 0 0-3.851.907 3.32 3.32 0 0 0-1.121 2.732 3.12 3.12 0 0 0 .547 1.936 1.93 1.93 0 0 0 1.642.72Zm16.924 3.564a5.04 5.04 0 0 1-3.44-1.2 5.08 5.08 0 0 1-1.368-4V33.025h-1.1q-1.055 0-1.055-1.632v-.569q0-1.632 1.055-1.632h1.095l.587-3.717q.2-1.1 1.72-1.1h.934q1.76 0 1.76 1.1v3.717h1.994q1.055 0 1.055 1.632v.569q0 1.632-1.055 1.632H45.07v10.589a2.95 2.95 0 0 0 .254 1.443.99.99 0 0 0 .919.417 3 3 0 0 0 .8-.076 1.8 1.8 0 0 1 .528-.076q.313 0 .508.474a5 5 0 0 1 .293 1.044 5.6 5.6 0 0 1 .093.873 1.03 1.03 0 0 1-.547.854 4.2 4.2 0 0 1-1.388.55 7.5 7.5 0 0 1-1.654.19Zm10.946 0a5.4 5.4 0 0 1-4.164-1.575 6.13 6.13 0 0 1-1.466-4.346 6.66 6.66 0 0 1 .977-3.586 6.6 6.6 0 0 1 3.166-2.505 15.15 15.15 0 0 1 5.822-.928v-1.025a2.78 2.78 0 0 0-.606-1.879 2.65 2.65 0 0 0-2.091-.7 9.8 9.8 0 0 0-2.541.3 16 16 0 0 0-1.876.607 3.3 3.3 0 0 1-1.055.3q-.352 0-.567-.493a4.6 4.6 0 0 1-.313-1.139 7.4 7.4 0 0 1-.093-1.063q0-.493 1-1.044a10.5 10.5 0 0 1 2.561-.929 13.6 13.6 0 0 1 3.205-.38q3.87 0 5.629 1.723a6.07 6.07 0 0 1 1.76 4.533v7.628a22 22 0 0 0 .2 3.492 9.7 9.7 0 0 1 .2 1.556.69.69 0 0 1-.449.607 4.4 4.4 0 0 1-1.075.363 11 11 0 0 1-1.214.189q-.587.057-.86.057a.96.96 0 0 1-.919-.453 6.2 6.2 0 0 1-.488-1.632 6.6 6.6 0 0 1-1.8 1.575 5.4 5.4 0 0 1-2.934.74Zm1.563-3.567a2.9 2.9 0 0 0 1.588-.453 3.7 3.7 0 0 0 1.184-1.213v-4.63a6.2 6.2 0 0 0-3.851.907 3.32 3.32 0 0 0-1.114 2.733 3.12 3.12 0 0 0 .547 1.936 1.93 1.93 0 0 0 1.642.72Zm14.23 3.377a3.4 3.4 0 0 1-1.622-.285.9.9 0 0 1-.488-.816V23.88a1.226 1.226 0 0 1 1.368-1.4h6.411q8.092 0 8.092 8.083 0 8.121-8.092 8.121h-2.585v9.339a.9.9 0 0 1-.488.816 3.4 3.4 0 0 1-1.622.285Zm3.089-14.688h2.58a2.73 2.73 0 0 0 2.326-.907 5 5 0 0 0 .684-2.96 4.9 4.9 0 0 0-.684-2.922 2.73 2.73 0 0 0-2.326-.907h-2.585Zm14.737 14.691a3.3 3.3 0 0 1-1.588-.285.9.9 0 0 1-.488-.816v-17.8a.9.9 0 0 1 .487-.812 3.3 3.3 0 0 1 1.588-.285h.86a3.3 3.3 0 0 1 1.588.285.9.9 0 0 1 .488.816v17.8a.9.9 0 0 1-.488.816 3.3 3.3 0 0 1-1.588.285Zm.467-22.123a4.7 4.7 0 0 1-1.916-.285.89.89 0 0 1-.587-.816V23.16a.87.87 0 0 1 .587-.778 4.7 4.7 0 0 1 1.916-.285 4.9 4.9 0 0 1 1.876.266.85.85 0 0 1 .587.8v2.733a.89.89 0 0 1-.587.816 4.6 4.6 0 0 1-1.879.282Zm11.259 22.31a5.04 5.04 0 0 1-3.44-1.2 5.08 5.08 0 0 1-1.368-4V21.565a.9.9 0 0 1 .488-.816 3.3 3.3 0 0 1 1.588-.285h.86a3.3 3.3 0 0 1 1.588.285.9.9 0 0 1 .488.816v22.049a2.95 2.95 0 0 0 .254 1.443.99.99 0 0 0 .919.417 3 3 0 0 0 .8-.076 1.8 1.8 0 0 1 .528-.076q.313 0 .508.474a5 5 0 0 1 .293 1.044 5.6 5.6 0 0 1 .093.873 1.03 1.03 0 0 1-.547.854 4.2 4.2 0 0 1-1.388.55 7.5 7.5 0 0 1-1.669.19Zm58.95 0a5.04 5.04 0 0 1-3.44-1.2 5.08 5.08 0 0 1-1.368-4V33.025h-1.095q-1.055 0-1.055-1.632v-.569q0-1.632 1.055-1.632h1.095l.587-3.717q.2-1.1 1.72-1.1h.934q1.76 0 1.76 1.1v3.717h1.994q1.055 0 1.055 1.632v.569q0 1.632-1.055 1.632h-1.989v10.589a2.95 2.95 0 0 0 .254 1.443.99.99 0 0 0 .919.417 3 3 0 0 0 .8-.076 1.8 1.8 0 0 1 .528-.076q.313 0 .508.474a5 5 0 0 1 .293 1.044 5.6 5.6 0 0 1 .093.873 1.03 1.03 0 0 1-.547.854 4.2 4.2 0 0 1-1.388.55 7.5 7.5 0 0 1-1.662.19Z",
    "data-name": "Path 3846"
  })));
};
export default SvgDataPilotLogo;